module.exports = __webpack_public_path__ + "img/bg_function03_3_d.a2cd62b3.png";